// Drives /resources. Edit freely. Rewritten 2026-09-29 by the ClearMakes Inbox SEO run
// (gtm/products/clearmakes-inbox/seo/): the old comparison and "AI assistant" pages were merged
// into current pages (301s in gtm/products/clearmakes-inbox/seo/redirects.md).
export const resourceGroups: { heading: string; links: { label: string; href: string }[] }[] = [
  {
    heading: "Guides",
    links: [
      { label: "All guides", href: "/guides" },
      { label: "How to forward emails to a Slack channel", href: "/guides/forward-email-to-slack-channel" },
      { label: "How to auto-reply to common customer questions", href: "/guides/auto-reply-to-common-customer-questions" },
      { label: "ClearMakes Inbox documentation", href: "/documentation" },
    ],
  },
  {
    heading: "Comparisons",
    links: [{ label: "Zapier alternatives for email and chat", href: "/alternatives/zapier" }],
  },
  {
    heading: "Integration guides",
    links: [
      { label: "All Inbox integrations", href: "/integrations" },
      { label: "Gmail to Slack automation", href: "/integrations/gmail-to-slack" },
      { label: "Outlook to Slack automation", href: "/integrations/outlook-to-slack" },
      { label: "Post Outlook emails to Teams", href: "/integrations/outlook-to-teams" },
      { label: "Add email leads to HubSpot", href: "/integrations/email-to-hubspot" },
      { label: "Gmail automation", href: "/gmail-integration" },
      { label: "Outlook email automation", href: "/outlook-integration" },
      { label: "Slack automation", href: "/slack-integration" },
      { label: "Microsoft Teams automation", href: "/teams-integration" },
    ],
  },
  {
    heading: "By team and use case",
    links: [
      { label: "For founders", href: "/for-founders" },
      { label: "For freelancers", href: "/for-freelancers" },
      { label: "For remote teams", href: "/for-remote-teams" },
      { label: "Lead response automation", href: "/lead-response-automation" },
      { label: "Smart FAQ", href: "/smart-faq" },
      { label: "Workflows", href: "/workflows" },
    ],
  },
];
